import React, { Component } from "react";
import firebase from "firebase";
import { css } from "emotion";
import { Button, Container, Text } from "../../components";
import { Redirect } from "react-router-dom";

class DashboardBlank extends Component {
  state = {
    newAssessmentKey: null,
  };

  createAssessment = async () => {
    const newAssessmentRef = firebase
      .database()
      .ref()
      .child("church")
      .child(this.props.user.uid)
      .child("assessments")
      .push();
    await newAssessmentRef.set({
      timeStarted: firebase.database.ServerValue.TIMESTAMP,
    });
    this.setState({ newAssessmentKey: newAssessmentRef.key });
  };

  render() {
    if (this.state.newAssessmentKey) {
      return <Redirect to={`/dashboard/${this.state.newAssessmentKey}`} />;
    }

    return (
      <Container
        className={css`
          margin: 0;
        `}
      >
        <div
          className={css`
            position: relative;
            margin-top: 20vh;
          `}
        >
          <Text.H1>Let’s check your church’s Vital Signs!</Text.H1>
          <br />
          <Text.Large measure leading="copy">
            This assessment will collect data about your church's reach,
            connection, staffing, finances, facilities and more and benchmark
            the numbers you enter against the data we have been collecting for
            years on church health metrics.
          </Text.Large>
          <br />
          <Text.Large measure leading="copy">
            Once you begin, your answers will be saved as you go. But, we’ve
            found it can be helpful to review the survey questions in advance
            and pull together your answers so you can complete the assessment in
            one session, if desired.{" "}
            <a
              href="https://2343950.fs1.hubspotusercontent-na1.net/hubfs/2343950/2023%20Vital%20Signs%20Assessment%20Questions%20-%20Learning%20Hub.pdf"
              target="_blank"
            >
              Review the questions here
            </a>
            .
          </Text.Large>
          <br />
          <Button kind="primary" onClick={this.createAssessment}>
            Start the assessment
          </Button>
        </div>
      </Container>
    );
  }
}

export default DashboardBlank;



// WEBPACK FOOTER //
// ./src/screens/dash/DashboardBlank.js